import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DestinationAccountNotAllowedTooltip(props) {
  const {
    children,
    disabled
  } = props;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: disabled,
    use: "longform",
    placement: "left",
    maxInlineSize: "400px",
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.title"
    }),
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.subtitle"
      }), /*#__PURE__*/_jsxs(List, {
        styled: true,
        wrapChildren: true,
        children: [/*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.superAdmin"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.enterpriseSubscription"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.differentLocation"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.destinationAccountNotAllowed.sandboxAccount"
          })
        })]
      })]
    }),
    children: children
  });
}
export default DestinationAccountNotAllowedTooltip;